module.exports = __webpack_public_path__ + "img/play-video.6b37b6fd.svg";